import { render, staticRenderFns } from "./MSelectColorBase.vue?vue&type=template&id=62b3a68a&"
import script from "./MSelectColorBase.vue?vue&type=script&lang=ts&"
export * from "./MSelectColorBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports